import axios from '@/utils/api'
import { CLEAR_DOCUMENTO_AUTENTICO, SET_DOCUMENTO_AUTENTICO } from '../../../mutation-types'

const state = {
  item: {}
}

const getters = {
  item: state => state.item
}

const mutations = {
  [SET_DOCUMENTO_AUTENTICO] (state, documento) {
    state.item = documento
  },

  [CLEAR_DOCUMENTO_AUTENTICO] (state) {
    state.item = {}
  }
}

const actions = {
  async consultaAutenticidade ({ commit }, protocolo) {
    const documento = await axios({
      method: 'get',
      url: `publico/documentoAutenticavel/autenticar/${protocolo}`
    })
    commit(SET_DOCUMENTO_AUTENTICO, documento)
  },

  async consultaAutenticidadeError ({ commit }, protocolo) {
    const documento = await axios({
      method: 'get',
      url: `publico/documentoAutenticavel/autenticar/${protocolo}`,
      error: true
    })
    return documento
  },

  clearDocumento ({ commit }) {
    commit('CLEAR_DOCUMENTO_AUTENTICO')
  },

  async download ({ commit }, id) { // eslint-disable-line
    await axios({
      method: 'get',
      url: `publico/documentoAutenticavel/download/${id}`,
      responseType: 'blob' // Importante em caso de download de files
    })
  },

  async downloadArquivoEstatico ({ commit }, codigo) {
    await axios({
      method: 'get',
      url: `${process.env.ROOT_URL}publico/arquivo/${codigo}`,
      responseType: 'blob' // Importante em caso de download de files
    })
  }

}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/documentosAutenticaveis.js